export class ClipsFetchError extends Error {}
